import { Button, Form, FormControl, Modal, TextInput } from 'callahan-react'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'

import { submitForceScan } from '../../actions/force-scan-actions'
import BackButton from '../../components/BackButton'

import './ForceScan.css'
import '../default.css'

const propTypes = {
  isSubmittingForceScan: PropTypes.bool,
  submitForceScanError: PropTypes.bool,
  code: PropTypes.number,
  body: PropTypes.string
}
// export unconnected component for testing
export class ForceScan extends Component {
  constructor(props) {
    super(props)
    this.state = {
      pcode: '',
      domain: '',
      reason: '',
      modalOpen: false,
      showValidation: false
    }
  }

  toggleModal = () => {
    this.setState({ modalOpen: !this.state.modalOpen })
  }

  isValidPcode = () => {
    const { pcode } = this.state
    return pcode.length === 13 || (pcode.length === 15 && pcode.substring(0, 2) === 'p-')
  }

  normalizePcode = pcode => {
    return pcode.length === 15 && pcode.substring(0, 2) === 'p-' ? pcode.substring(2) : pcode
  }

  // Update domain input
  handleDomainChange = event => {
    const domain = event.target.value
    this.setState({ domain, showValidation: false })
  }

  // Update pcode input
  handlePcodeChange = event => {
    const pcode = event.target.value
    this.setState({ pcode, showValidation: false })
  }

  // Update reason input
  handleReasonChange = event => {
    const reason = event.target.value
    this.setState({ reason, showValidation: false })
  }

  validatePcode = () => {
    if (!this.isValidPcode()) {
      return { result: 'error', message: 'Enter valid p-code' }
    }
    return { result: 'success' }
  }

  validateDomain = () => {
    if (this.state.domain === '') {
      return { result: 'error', message: 'Enter domain' }
    }
    return { result: 'success' }
  }

  validateReason = () => {
    if (this.state.reason === '') {
      return { result: 'error', message: 'Enter reason' }
    }
    return { result: 'success' }
  }

  // Submit form when user presses enter
  enterToSubmit = event => {
    if (event.which === 13) {
      this.submitForm()
      event.preventDefault()
    }
  }

  // Post form info to backend
  submitForm = () => {
    const { pcode, domain, reason } = this.state
    if (this.isValidPcode() && domain.length > 0 && reason.length > 0) {
      let query = {
        pcode: this.normalizePcode(pcode),
        domain,
        reason
      }
      this.props.dispatch(submitForceScan(query)).then(() => {
        this.toggleModal()
      })
    } else {
      this.setState({ showValidation: true })
    }
  }

  resetFormValues = () => {
    this.setState({ pcode: '', domain: '', reason: '', modalOpen: false })
  }

  render() {
    const modalFooter = (
      <Button buttonType="primary" buttonMode="small" onClick={this.toggleModal} text="Close" />
    )
    const formInputData = [
      {
        label: 'p-code',
        validationMethod: this.validatePcode,
        value: this.state.pcode,
        size: 'small',
        required: true,
        onChange: this.handlePcodeChange
      },
      {
        label: 'domain',
        validationMethod: this.validateDomain,
        value: this.state.domain,
        size: 'small',
        required: true,
        onChange: this.handleDomainChange
      },
      {
        label: 'reason',
        validationMethod: this.validateReason,
        value: this.state.reason,
        size: 'large',
        required: true,
        onChange: this.handleReasonChange
      }
    ]
    const formControl = formInputData.map(input => (
      <FormControl
        className="fs-form-control"
        key={input.label}
        label={input.label}
        validationMethod={input.validationMethod}
        value={input.value}
        size={input.size}
        required={input.required}
      >
        <TextInput value={input.value} onChange={input.onChange} onKeyPress={this.enterToSubmit} />
      </FormControl>
    ))
    return (
      <div className="main-content">
        <div className="title-bar">
          <BackButton onClick={this.resetFormValues} />
          <h1 className="page-title">Force Scan</h1>
          <div className="title-right-padding" />
        </div>
        <hr />
        <Form className="formInput" layout="horizontal" showValidation={this.state.showValidation}>
          {formControl}
        </Form>
        <div className="button-container fs-button-container">
          <Button className="form-button fs-form-button" onClick={this.submitForm}>
            Submit
          </Button>
          <Button
            className="form-button fs-form-button"
            buttonType="tertiary"
            onClick={this.resetFormValues}
          >
            Reset
          </Button>
        </div>
        <Modal
          open={this.state.modalOpen}
          onClose={this.toggleModal}
          header={this.props.code ? this.props.code : 200}
          footer={modalFooter}
        >
          <p>{this.props.body}</p>
        </Modal>
      </div>
    )
  }
}

ForceScan.propTypes = propTypes

// map code and body state to props, then change state accesses to prop acceses
function mapStateToProps(state) {
  const { forceScan } = state
  return {
    isSubmittingForceScan: forceScan.isSubmittingForceScan,
    submitForceScanError: forceScan.submitForceScanError,
    code: forceScan.code,
    body: forceScan.body
  }
}

export default connect(mapStateToProps)(ForceScan)



// WEBPACK FOOTER //
// ./src/pages/ForceScan/ForceScan.js